export const GET_ALL_TEAMS = `
    query Teams {
        teams{
            id
            name
            department {
                id
                name
            }
            users {
                id
                name
            }
        }
    }
`;

export const CREATE_TEAM = `
    mutation createTeam($name: String!, $departmentId: ID!, $userIds: [ID!]!) {
        createTeam(name: $name, departmentId: $departmentId, userIds: $userIds) {
            errors{
                description
                property
            }
            team{
                id
                name
            }
        }
    }
`;

export const DELETE_TEAM = `
  mutation DeleteTeam($id:ID!) {
    deleteTeam(id: $id) {
      result
      errors {
        property
        description
      }
    }
  }
`;

export const GET_TEAM = `
    query GetTeam($id: ID!) {
        team(id: $id) {
            id
            name
            department{
                id
                name
            }
            users{
                id
                name
            }
        }
    }
`;

export const UPDATE_TEAM = `
    mutation UpdateTeam($id: ID!, $name: String!, $departmentId: ID!, $userIds: [ID!]!) {
        updateTeam(id: $id, name: $name, departmentId: $departmentId, userIds: $userIds) {
            errors{
                description
                property
            }
            team{
                id
                name
            }
        }
    }
`;
